export default __webpack_public_path__ + "images/indigo-40.png";